"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var icons_1 = __importDefault(require("../../theme/icons"));
require("./style.sass");
// Import "../../theme/Sass"
var TextInput = function (_a) {
    var error = _a.error, icon = _a.icon, defaultValue = _a.defaultValue, value = _a.value, placeholder = _a.placeholder, type = _a.type, disabled = _a.disabled, label = _a.label, inputStyle = _a.inputStyle, onChange = _a.onChange, autoFocus = _a.autoFocus, mainStyle = _a.mainStyle, InputLabelStyle = _a.InputLabelStyle;
    var _b = (0, react_1.useState)("input-control"), inputClass = _b[0], setInputClass = _b[1], _c = (0, react_1.useState)("input-control-no-shadow"), noShadowInput = _c[0], setNoShadowInput = _c[1], _d = (0, react_1.useState)(false), showPassword = _d[0], setShowPassword = _d[1], t = (0, react_i18next_1.useTranslation)().t, pass_img = showPassword ? (react_1.default.createElement(icons_1.default, { name: "eyeOpen", width: 20, height: 20, className: "icon_orange" })) : (react_1.default.createElement(icons_1.default, { name: "eyeClose", width: 20, height: 20, className: "icon_orange" }));
    (0, react_1.useEffect)(function () {
        if (error) {
            setInputClass("input-control input-error-control");
            setNoShadowInput("input-control-no-shadow input-error-control");
        }
        else {
            setInputClass("input-control");
            setNoShadowInput("input-control-no-shadow");
        }
    }, [error]);
    var handlePasswordDisplay = function () {
        setShowPassword(!showPassword);
    };
    return (react_1.default.createElement("div", { style: mainStyle
            ? {
                margin: "0.31rem 0",
                display: "flex",
                flexDirection: "column",
            }
            : {
                margin: "0.31rem 0",
                display: "flex",
                flex: 1,
                width: "100%",
                flexDirection: "column",
            } },
        error && react_1.default.createElement("p", { className: "error" }, t(error)),
        label ? (react_1.default.createElement("div", { className: "input-label", style: InputLabelStyle },
            react_1.default.createElement("label", { className: "label" }, label),
            react_1.default.createElement("div", { className: "input-no-shadow", style: inputStyle },
                react_1.default.createElement("input", { autoFocus: autoFocus, className: noShadowInput, defaultValue: defaultValue, disabled: disabled ? disabled : false, 
                    // onBlur={() => setFocus(false)}
                    onChange: onChange, 
                    //   Id={id ? id : ''}
                    // onFocus={() => setFocus(true)}
                    placeholder: placeholder ? t(placeholder) : "", type: showPassword ? "text" : type ? type : "text", value: value })))) : (react_1.default.createElement("div", { className: error ? "input-error" : "input" },
            icon && react_1.default.createElement("span", { className: "input-group-addon" }, icon),
            react_1.default.createElement("input", { autoFocus: autoFocus, className: inputClass, defaultValue: defaultValue, disabled: disabled, 
                // onBlur={() => setFocus(false)}
                onChange: onChange, 
                // onFocus={() => setFocus(true)}
                placeholder: placeholder ? t(placeholder) : "", type: showPassword ? "text" : type ? type : "text", value: value }),
            type === "password" && (react_1.default.createElement("div", { className: "pass-eye-con" },
                react_1.default.createElement("span", { onClick: handlePasswordDisplay }, pass_img)))))));
};
exports.default = TextInput;
